// extracted by mini-css-extract-plugin
export default {"body":"EditProfile_body__QLjtK"};